<div>
  <button nz-button [nzType]="data.type" class="btn-with-addon">
    <span class="btn-addon">
      <i [class]="data.icon" class="btn-addon-icon"></i>
    </span>
    {{ data.title }}
  </button>
</div>